export const Superstition_Device_Points_Config = {
  STATUS_891_DATA_POINTS: [
    {
      label: '891 status',
      pointName: '891_status',
      engineeringId: 'rtac_1',
    },
  ],
  STATUS_52H1_DATA_POINTS: [
    {
      label: '52H1 st atus',
      pointName: '52h1_status',
      engineeringId: 'rtac_1',
    },
  ],
  STATUS_52F1_DATA_POINTS: [
    {
      label: '52F1 status',
      pointName: '52f1_status',
      engineeringId: 'rtac_1',
    },
  ],
  STATUS_52F2_DATA_POINTS: [
    {
      label: '52F2 status',
      pointName: '52f2_status',
      engineeringId: 'rtac_1',
    },
  ],
};
